import { MediaQueryTarget } from '@pkg/providers';

import { type LeaderboardBreakpointCondition, type LeaderboardBreakpoints, LeaderboardColumn } from '../types';

export const PLAYER_MIN_COLUMNS = [LeaderboardColumn.Player, LeaderboardColumn.ProfitLoss];
export const TEAM_MIN_COLUMNS = [LeaderboardColumn.Team];

const ORDERED_BREAKPOINTS: LeaderboardBreakpoints[] = [
    MediaQueryTarget.Mobile,
    MediaQueryTarget.Tablet,
    MediaQueryTarget.Desktop,
    MediaQueryTarget.Widescreen,
    MediaQueryTarget.QuadHdY,
];

function breakpointReached(current: LeaderboardBreakpoints, target: LeaderboardBreakpoints) {
    const currentIndex = ORDERED_BREAKPOINTS.indexOf(current);
    const targetIndex = ORDERED_BREAKPOINTS.indexOf(target);

    return currentIndex >= targetIndex;
}

export function getActiveBreakpoint(breakpoints: LeaderboardBreakpointCondition): LeaderboardBreakpoints {
    if (breakpoints[MediaQueryTarget.QuadHdY]) return MediaQueryTarget.QuadHdY;
    if (breakpoints[MediaQueryTarget.Widescreen]) return MediaQueryTarget.Widescreen;
    if (breakpoints[MediaQueryTarget.Desktop]) return MediaQueryTarget.Desktop;
    if (breakpoints[MediaQueryTarget.Tablet]) return MediaQueryTarget.Tablet;

    return MediaQueryTarget.Mobile;
}

export function columnsFromBreakpoint(breakpoint: LeaderboardBreakpoints, isTeamsView?: boolean) {
    const columns = isTeamsView ? [...TEAM_MIN_COLUMNS] : [...PLAYER_MIN_COLUMNS];

    if (isTeamsView) {
        if (breakpointReached(breakpoint, MediaQueryTarget.Tablet)) {
            columns.push(LeaderboardColumn.ProfitLoss);
        }

        if (breakpointReached(breakpoint, MediaQueryTarget.Desktop)) {
            columns.push(LeaderboardColumn.Investment);
        }

        if (breakpointReached(breakpoint, MediaQueryTarget.Widescreen)) {
            columns.push(LeaderboardColumn.CurrentValue);
        }

        columns.push(LeaderboardColumn.Members);
    } else {
        if (breakpointReached(breakpoint, MediaQueryTarget.Tablet)) {
            columns.push(LeaderboardColumn.CurrentValue);
        }

        if (breakpointReached(breakpoint, MediaQueryTarget.Desktop)) {
            columns.push(LeaderboardColumn.Quantity);
        }

        if (breakpointReached(breakpoint, MediaQueryTarget.Widescreen)) {
            columns.push(LeaderboardColumn.TopPicks);
        }

        if (breakpointReached(breakpoint, MediaQueryTarget.QuadHdY)) {
            columns.push(LeaderboardColumn.Investment);
        }
    }
    return columns;
}
